import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import type { ApiError, QueryFiltersDomainOnly } from '../types';
import { buildUniversalMfaDomainQueryParams } from '../constants/utils';

const END_POINT = '/metric/protectedUsers';

const fetchProtectedUsers = async (filters: QueryFiltersDomainOnly): Promise<number> => {
    const data = await apiGet<number>(`${API_BASE_URL}${END_POINT}`, buildUniversalMfaDomainQueryParams(filters));
    return data;
};

export const useProtectedUsers = (filters: QueryFiltersDomainOnly): UseQueryResult<number, ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.protectedUsers(filters),
        queryFn: () => fetchProtectedUsers(filters)
    });
};
